/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Operatedby_Before1Inputs */

const ja_playdata_about_operatedby_before1 = /** @type {(inputs: Playdata_About_Operatedby_Before1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運営は、`)
};

const en_playdata_about_operatedby_before1 = /** @type {(inputs: Playdata_About_Operatedby_Before1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA is operated by `)
};

/**
* | output |
* | --- |
* | "PLAYDATA is operated by" |
*
* @param {Playdata_About_Operatedby_Before1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_about_operatedby_before1 = /** @type {((inputs?: Playdata_About_Operatedby_Before1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Operatedby_Before1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_operatedby_before1(inputs)
	return en_playdata_about_operatedby_before1(inputs)
});
export { playdata_about_operatedby_before1 as "playdata_about_operatedBy_before" }